import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Properties } from '../../models/polymer/Properties.model'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api';
import { PolymerCrypto } from '../../utils/encryptor';
import { AdministrativeRole, MyInfoWithDOD } from '../../models/polymer/MyInfo.model';


interface QueryParams {
  uinfin: string
  singpass_token: string
}

export const hdbPropertyApi = createApi({
  reducerPath: 'hdbPropertyApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getHDBPropertyByNric: builder.query<Properties[], QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/residential/list`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: Properties[], meta, arg)=>{        
        response = response.map(property => new Properties({
          ...property,
          owners: property.owners.map(owner => new MyInfoWithDOD(owner)),
          additional_roles: property.additional_roles.map(additionalRole => new AdministrativeRole(additionalRole)),
        }));

        const encryptedUinfin = PolymerCrypto.encryption(arg.uinfin);
        const processedProperties = [];

        for (const property of response) {
          const owner = property.owners.find(owner => owner.uinfin === encryptedUinfin);
          if (!!owner) {
            processedProperties.push(new Properties({
              ...property,
              current_user: owner,
            }));
          }

          const matchingAdditionalRoles = property.additional_roles.filter(additionalRole => additionalRole.uinfin === encryptedUinfin);
          for (const additionalRole of matchingAdditionalRoles) {
            processedProperties.push(new Properties({
              ...property,
              current_user: additionalRole,
            }));
          }
        }
        
        return processedProperties;
      }
    }),
  }),
})

export const { useGetHDBPropertyByNricQuery } = hdbPropertyApi


/**THIS IS CHECK ADDITIONAL ROLE */